/**
 * @generated SignedSource<<8a1fa6ccbf9425cf1e110085d750ad71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PaymentSource = "CASH" | "NONCE" | "RAINCHECK" | "SQUARE_CARD_ON_FILE" | "SQUARE_GIFT_CARD" | "SQUARE_HOUSE_ACCOUNT";
export type AddPaymentGiftCardToBookingInput = {
  bookingId: string;
  giftCardId: string;
};
export type useAddPaymentGiftCardToBookingMutation$variables = {
  input: AddPaymentGiftCardToBookingInput;
  patronLoyalty: boolean;
};
export type useAddPaymentGiftCardToBookingMutation$data = {
  readonly responsePayload: {
    readonly booking: {
      readonly id: string;
      readonly ownerClient?: {
        readonly squareGiftCards?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly balance: number;
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly paymentGiftCards?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly projectedCreditApplications?: ReadonlyArray<{
        readonly amount: number;
        readonly paymentSource: PaymentSource;
        readonly raincheck: {
          readonly id: string;
        } | null | undefined;
        readonly squareGiftCard: {
          readonly ganLastFour: string | null | undefined;
          readonly id: string;
        };
      }>;
      readonly totalDueAfterCredits: number | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useAddPaymentGiftCardToBookingMutation = {
  response: useAddPaymentGiftCardToBookingMutation$data;
  variables: useAddPaymentGiftCardToBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patronLoyalty"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDueAfterCredits",
  "storageKey": null
},
v8 = [
  (v6/*: any*/)
],
v9 = {
  "condition": "patronLoyalty",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectedCreditApplication",
      "kind": "LinkedField",
      "name": "projectedCreditApplications",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentSource",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCard",
          "kind": "LinkedField",
          "name": "squareGiftCard",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ganLastFour",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Raincheck",
          "kind": "LinkedField",
          "name": "raincheck",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "hasNonZeroBalance",
          "value": true
        }
      ],
      "concreteType": "SquareGiftCardConnection",
      "kind": "LinkedField",
      "name": "squareGiftCards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCardEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareGiftCard",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "balance",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "squareGiftCards(active:true,hasNonZeroBalance:true)"
    }
  ],
  "type": "Customer",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareGiftCardConnection",
  "kind": "LinkedField",
  "name": "paymentGiftCards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareGiftCardEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCard",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "ownerClient",
    "plural": false,
    "selections": [
      (v10/*: any*/)
    ],
    "storageKey": null
  },
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "ownerClient",
    "plural": false,
    "selections": [
      (v13/*: any*/),
      (v10/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": (v8/*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
      }
    ],
    "storageKey": null
  },
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddPaymentGiftCardToBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "AddPaymentGiftCardToBookingPayload",
        "kind": "LinkedField",
        "name": "addPaymentGiftCardToBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v12/*: any*/),
                "type": "StandardBooking",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v12/*: any*/),
                "type": "LessonBooking",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAddPaymentGiftCardToBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "AddPaymentGiftCardToBookingPayload",
        "kind": "LinkedField",
        "name": "addPaymentGiftCardToBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v14/*: any*/),
                "type": "StandardBooking",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v14/*: any*/),
                "type": "LessonBooking",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ca072f46f6a2dbeea9cc0853d503a33",
    "id": null,
    "metadata": {},
    "name": "useAddPaymentGiftCardToBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useAddPaymentGiftCardToBookingMutation(\n  $input: AddPaymentGiftCardToBookingInput!\n  $patronLoyalty: Boolean!\n) {\n  responsePayload: addPaymentGiftCardToBooking(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    booking {\n      __typename\n      id\n      totalDueAfterCredits\n      projectedCreditApplications @include(if: $patronLoyalty) {\n        amount\n        paymentSource\n        squareGiftCard {\n          id\n          ganLastFour\n        }\n        raincheck {\n          id\n        }\n      }\n      ... on StandardBooking {\n        ownerClient {\n          __typename\n          ... on Customer {\n            squareGiftCards(active: true, hasNonZeroBalance: true) {\n              edges {\n                node {\n                  id\n                  balance\n                }\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        paymentGiftCards {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n      ... on LessonBooking {\n        ownerClient {\n          __typename\n          ... on Customer {\n            squareGiftCards(active: true, hasNonZeroBalance: true) {\n              edges {\n                node {\n                  id\n                  balance\n                }\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        paymentGiftCards {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7097d7b9ccd9578a6ba710ce4abd34a";

export default node;
